import { storageGet, storageSet } from "utils/safeStorage";

/**
 * Did this visit start from a paid ad? (1NOW-11115)
 *
 * `markLandingSource()` runs once at boot, while the landing URL is still the one the ad linked
 * to, and keeps the answer in sessionStorage so it survives the renter clicking around. After
 * that `landedFromAd()` is a plain read. Nothing is ever written for organic visits, so a renter
 * who arrives from an ad and later opens a clean link in the same tab is still an ad visitor
 * for that session.
 */
const KEY = "landedFromAd";
const CLICK_IDS = ["fbclid", "gclid", "gbraid", "wbraid", "ttclid", "msclkid"];
const PAID_MEDIUMS = ["paid", "cpc", "ppc", "paid_social"];

export const isAdUrl = (search: string): boolean => {
  const params = new URLSearchParams(search);
  const keys = new Set<string>();
  params.forEach((_value, key) => keys.add(key.toLowerCase()));
  if (CLICK_IDS.some((id) => keys.has(id))) return true;
  let medium: string | null = null;
  params.forEach((value, key) => {
    if (key.toLowerCase() === "utm_medium") medium = value;
  });
  return medium !== null && PAID_MEDIUMS.includes((medium as string).trim().toLowerCase());
};

export const markLandingSource = (): void => {
  try {
    if (isAdUrl(window.location.search)) storageSet("session", KEY, "true");
  } catch {
    /* no window or no storage: the visit is read as organic */
  }
};

export const landedFromAd = (): boolean => storageGet("session", KEY) === "true";
